/**
 * <TutorScoreCardSkeleton> — la forme de « Mon score » pendant le premier chargement.
 *
 * Le cas courant : un masteur classé, trois périodes. Les onglets des périodes gardent leur rangée
 * (`<TabsSkeleton>`), les deux chiffres la taille de leur tuile, les quatre axes leurs tuiles
 * d'encart — la même grille que la carte.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"
import { TabsSkeleton } from "../../molecules/Tabs"

const AXES = ["satisfaction", "interaction", "productivity", "punctuality"]

export function TutorScoreCardSkeleton() {
    return (
        <Card p="4">
            <Stack gap="4">
                <TabsSkeleton size="sm" widths={[70, 104, 112]} />
                <Row gap="6">
                    <Stack gap="0">
                        <Skeleton textSize="text-2xl" width={72} />
                        <Skeleton textSize="text-sm" width={86} />
                    </Stack>
                    <Stack gap="0">
                        <Skeleton textSize="text-2xl" width={48} />
                        <Skeleton textSize="text-sm" width={74} />
                    </Stack>
                </Row>
                <View style={styles.grid}>
                    {AXES.map((axis) => (
                        <View key={axis} style={styles.tile}>
                            <Stack gap="1">
                                <Skeleton textSize="text-xs" width={96} />
                                <Skeleton textSize="text-xl" width={52} />
                                <Skeleton textSize="text-xs" width={80} />
                            </Stack>
                        </View>
                    ))}
                </View>
                <Skeleton textSize="text-sm" width={120} />
            </Stack>
        </Card>
    )
}

const styles = StyleSheet.create((theme) => ({
    grid: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: theme.spacing["3"],
    },
    tile: {
        flexGrow: 1,
        flexBasis: "40%",
        minWidth: 130,
        padding: theme.spacing["3"],
        borderRadius: theme.radius.md,
        backgroundColor: theme.colors["surface-subtle"],
    },
}))
